export const ListPageMixin = {
    data () {
        return {
            // 削除ダイアログの制御値
            removeOverlay: false,
            // 会員ID
            member_no: '',
            // 氏名
            full_name: '',
            // 処理の結果
            process: {
                result: '',
                resultText: ''
            },
            // モーダルの制御値
            dialog: false,
            // 削除時のID
            id: '',
            // ボタン連打制御値
            processing: false,
            // エラー
            error: '',
            // v-data-tableのデータ
            desserts: [],
            // 一覧の制御値
            page: 1,
            pageCount: 0,
            limit_rows: 5,
            begin_row: 0,
            Info: []
        };
    },
    watch: {
        removeOverlay () {
            if (this.removeOverlay === false) {
                this.process.result = '';
            }
        }
    },
    methods: {
        Initialize () {
            this.id = '';
            this.page = 1;
            this.pageCount = 0;
            this.member_no = '';
            this.removeOverlay = false;
            this.process.result = '';
            this.process.resultText = '';
            this.processing = false;
            this.desserts = [];
            this.begin_row = 0;
            this.limit_rows = 5;
        },
        removeOverlayStart (item) {
            this.removeOverlay = true;
            this.id = item.id;
        },
        CloseModal () {
            this.Initialize();
            this.$emit('refresh-event');
            this.dialog = false;
        }
    }
};
